<template>
    <div class="textBook">
        <el-container>
            <studyCenterHeader activeIndex="textBook"></studyCenterHeader>
            <el-main>
                <div class="textBook-main">
                    <SubviewLine title=""></SubviewLine>
                    <div class="textBook-main-content">
                        <userInfo :tabIndex="3" @changeType="getTypeChange" :textType="textType"></userInfo>
                        <div class="textBook-main-detail" v-if="textType == 1">
                        <!-- 教材列表-->
                            <div class="textBook-main-detail-tab" v-if="textBookStatus == 1">
                                <div class="tab-item" v-for="(item,index) in textBookTab" :key="index" :class="[chooseTabIndex == index ?'activeTab':'']" @click="handleToChangeTextBookTab(index)">{{item.dictLabel}}</div>
                            </div>
                            <div class="textBook-booklist" v-if="textBookStatus == 1">
                                <div class="textBook-bookitem" v-for="(item,index) in textBookList" :key="index" @click="handleToCheckTextBook(item.id,item.title)">
                                    <img :src="item.image" alt="" class="bookImg">
                                    <span>{{item.title}}</span>
                                </div>
                            </div>
                            <div v-if="textBookStatus == 1" style="display: flex;align-items: center;justify-content: flex-end;margin-top: 20px;">
                                <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="textBookTotal">
                                </el-pagination>
                            </div>
							
							<!-- 教材目录-->
                            <div class="catelog-header" v-if="textBookStatus == 2">
                                <span style="color: #70CDCF;margin-right: 15px; cursor: pointer">{{textBookTab[chooseTabIndex].dictLabel}}</span><span style="cursor: pointer">-{{title}}</span>
                            </div>
                            <div class="catelog-list" v-if="textBookStatus == 2">
                                <div class="catelog-item" v-for="(item,index) in lessonList" :key="index" @click="handleToTextBookDetail(item.id)">
                                    <!-- <span class="catelog-index">第{{NumberReturnChinese(index + 1)}}篇</span> -->
									<span class="catelog-title">{{item.title}}</span>
                                </div>
                            </div>
                            <!--教材内容目录-->
                            <div class="textBook-detail-header" v-if="textBookStatus == 3">
                                <div class="tab-item" v-for="(item,index) in headerTab" :key="index" :class="[headerTabIndex == index ?'activeTab':'']" @click="changeTextBookTab(index)"> {{item.name}}
								</div>
                            </div>
                           <!-- 进度条 -->
                           <div class="voicePlay" v-if="textBookStatus == 3">
								<img v-if="!isPlay" src="@/assets/image/ylc/22.png" alt="" style="cursor: pointer" @click="playTheVoice" />
								<img v-if="isPlay" src="@/assets/image/ylc/005.png" alt="" style="cursor: pointer" @click="playTheVoice" />
								<div class="progress">
									<el-slider :show-tooltip="false" v-model="progress" @change="progeressChange"></el-slider>
								</div>
                           </div>
                           <!-- 时间条 -->
                           <div class="voice-time" v-if="textBookStatus == 3">{{ nowH }}:{{ nowM }}:{{ nowS }}/{{ h }}:{{ i }}:{{ s }}</div>
						   <!-- 课程同步文本 -->
							<div class="textBook-detail-content" v-if="textBookStatus == 3" v-html="lessonInfo"></div>
                        </div>
						<!-- 听力同步 -->
                        <div class="sentence" v-if="textType == 2">
                            <div class="sentence-header"  @click="showCourseList">
                                <img src="../../assets/image/ylc/24.png" alt="">
                                <span class="font-kai">{{ courseName }}—{{ bookName }}{{ teachName }}—unit{{ unitId }}</span>
								<div class="triangle"></div>
                            </div>
                            <div class="sentence-content" v-if="!isFinish">
                                <div class="sentence-content-title"></div>
                                <div class="sentence-question">
                                    <div class="sentence-question-num">{{nowIndex+1}}/{{ sentenceTotal }}</div>
                                    <div class="sentence-progress">
                                        <div :style="{width:progressWidth}"></div>
                                    </div>
                                </div>
                                <div class="sentence-cutDown">倒计时：{{seconds}}</div>
								<!-- 听力选词 -->
                                <div class="sentence-listen" v-if="sentenceType == 1">
                                    <div class="sentence-listen-input" v-if="!dialogShow">
                                        <div v-for="(item,index) in sentenceList[nowIndex].listenInput" :key="index" class="sentence-listen-input-item" :class="[item.name?'noBorder':'']">	
											<div>{{item.name}}</div>
											<img v-show="item.name" class="listen-close" src="../../assets/image/ylc/35.png"  alt="" @click="deleteSingle(index)">
										</div>
                                    </div>
									<!-- 选择项 -->
                                    <div class="sentence-listen-opionts" v-if="!dialogShow">
                                        <div v-for="(item,index) in sentenceList[nowIndex].listenOptions" :key="index" class="sentence-listen-opionts-item" :class="[item.choose?'activeOptions':'']" @click="chooseTheOptions(index)">{{ item.name }}</div>
                                    </div>
                                    <div class="sentence-listen-button">
                                        <div class="white-button" @click="playTheAudio">播音</div>
                                        <div class="white-button" @click="clearListen">撤销</div>
                                        <div class="blue-button" @click="handleToNext">下一个</div>
                                    </div>
                                </div>
                               <!-- 翻译选词 -->
								<div class="sentence-Translate" v-if="sentenceType == 2">
                                    <div class="sentence-Translate-zh">
                                        <span>{{sentenceList[nowIndex].translate}}</span>
                                    </div>
                                    <div class="sentence-listen-input">
                                        <div v-for="(item,index) in sentenceList[nowIndex].listenInput" :key="index" class="sentence-listen-input-item" :class="[item.name?'noBorder':'']">
										<div>{{item.name}}</div>
										<img v-show="item.name" class="listen-close" src="../../assets/image/ylc/35.png"  alt="" @click="deleteSingle(index)">
									</div>
                                    </div>
									
                                    <div class="sentence-listen-opionts">
                                        <div v-for="(item,index) in sentenceList[nowIndex].listenOptions" :key="index" class="sentence-listen-opionts-item" :class="[item.choose?'activeOptions':'']" @click="chooseTheOptions(index)">
											<div>{{item.name}}</div>
										</div>
                                    </div>
									
									
                                    <div class="sentence-listen-button">
                                        <div class="white-button" @click="clearListen">撤销</div>
                                        <div class="blue-button" @click="handleToNext">下一个</div>
                                    </div>
                                </div>
							</div>
                            <div class="Finish-score" v-if="isFinish">
                                <div>
									<img v-if="score >= 90 " src="../../assets/image/ylc/13.png" alt="">
									<img v-if="score < 90" src="../../assets/image/ylc/32.png" alt="">
								</div>
                                <div>{{score}}分</div>
                                <div>{{score == 100 ? '你太棒了！我好崇拜你喔！' : score >= 80 ? '真棒，继续保持！' : '加油，再来一次！'}}</div>
                                <div>
                                    <div @click="hanldeShowError">查看错题</div>
                                    <div @click="tryAgian(score >= 80)" v-if="unitId < unitListNum&&score >= 80">下一单元</div>
                                    <div @click="tryAgian(score < 80)" v-if="score < 80">再来一次</div>
                                </div>
                            </div>
                        </div>
                       
					   <!--错题集  -->
						<div class="errorQuestion-list" v-if="textType == 3">
                            <div class="errorQuestion-list-title">错题集</div>
                            <div class="errorQuestion-list-table">
                                <el-table :data="tableData" style="width: 100%" border stripe  header-cell-class-name="tableHeader" cell-class-name="tableCell" >
										
									<el-table-column label="序号" type="index" width="60" class="number-index"> </el-table-column>
                                    <el-table-column label="课本名称">
                                        <template slot-scope="scope">
                                            <span style="margin-left: 10px">{{ scope.row.title }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="测试名称">
                                        <template slot-scope="scope">
                                            <span style="margin-left: 10px">{{ scope.row.content }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="测试时间" width="170">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.createTime }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="得分" width="90">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.point }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="100">
                                        <template slot-scope="scope">
                                            <button class="checkButton" @click="hanldetoCheckError(scope.row.id)">查看</button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="display: flex;align-items: center;justify-content: flex-end;margin: 10px ;">
                                <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="tableTotal"
                                        @current-change="changeTablePage">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
		
		<!-- 选择课程 -->
        <el-dialog :visible.sync="dialogShow" lock-scroll width="900px" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeModal">
            <div class="course-title">
                <img src="../../assets/image/ylc/4.png" alt="">
                <span>所有课程</span>
            </div>
            <div class="course-list">
                <div class="course-list-header" >
                    <div style="width: 150px;height: 60px;display:flex;align-items:center;justify-content:center;font-size: 22px;color: #000000;opacity: 0.58;border-right:1px solid #DCDFE6;">学段</div>
                    <div style="width: 340px;height: 60px;display:flex;align-items:center;justify-content:center;font-size: 22px;color: #000000;opacity: 0.58;">课本</div>
                    <div style="width: 170px;height: 60px;display:flex;align-items:center;justify-content:center;font-size: 22px;color: #000000;opacity: 0.58;">教材</div>
                    <div style="width: 170px;height: 60px;display:flex;align-items:center;justify-content:center;font-size: 22px;color: #000000;opacity: 0.58;">单元</div>
                </div>
                <div class="course-list-content" >
                    <div class="learnPeriod">
                        <div class="learnPeriod-item" v-for="(item,index) in courseList" :key="index" :class="[courseId == item.dictValue ?'chooseClass':'']" @click="chooseCourse(item.dictValue,item.dictLabel)">{{item.dictLabel}}</div>
                    </div>
                    <div class="book-list">
                        <div class="book-item" v-for="(item,index) in bookList" :key="index" :class="[bookId == item.parentId ?'chooseClass':'']" @click="chooseBook(item.parentId,item.cateGoryName)">{{item.cateGoryName}}</div>
                    </div>
                    <div class="teach-list">
                        <div class="teach-item" v-for="(item,index) in teachList" :key="index" :class="[teachId == item.id ?'chooseClass':'']" @click="chooseTeach(item.id,item.title)">{{item.title}}</div>
                    </div>
                    <div class="unit-list">
                        <div class="unit-item" v-for="(item,index) in unitList" :key="index" :class="[unitId == item ?'chooseClass':'']" @click="chooseUnit(item)">unit{{item}}</div>
                    </div>
                </div>
            </div>
            <div class="dialog-button">
                <!-- <button @click="getSentenceList">确定</button> -->
            </div>
        </el-dialog>
		
		<!-- 错题集 -->
        <el-dialog :visible.sync="errorShow" lock-scroll width="900px">
            <div class="error-title">全部题目</div>
            <div class="error-list">
                <div class="error-item" v-for="(item,index) in questionList" :key="index">
                    <div class="error-item-left">
                        <div><span style="display: inline-block; width: 47px;">{{index+1}}、</span>{{item.content}}</div>
                        <div :style="{color:(!item.isRight?'#E02020':'#2F89FC')}">{{item.answer}}</div>
                        <div>{{item.translate}}</div>
                    </div>
                    <div class="error-item-right">
                        <img src="../../assets/image/ylc/26.png" alt="" v-if="item.isRight">
                        <img src="../../assets/image/ylc/25.png" alt="" v-else>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
	import { Message } from 'element-ui';
    import {getBookList,getLessonList,getLessonInfo,getGrade,getCategoryByTestStage,getBookByCategory,getUnitByBookId,getSentenceList,uploadSubjectIdReportList,uploadScore,selectSubjectReportList,getScoreList} from '@/api'
    let timer = null;
    export default {
        name: "textBook",
        data(){
            return{
                textBookTab:[],
                chooseTabIndex:0,
                textBookList:[],
                textBookTotal:1,
                textBookPage:1,
                textBookStatus:1,//1-教材列表 2-教材目录 3-课本详情
                headerTabIndex:0,
                headerTab:[{id:1,name:'目录'},{id:2,name:'英文'},{id:3,name:'中文'}],
                draggable:true,
                value:0,
                textType:1,//1-教材同步 2-句子同步 3-错题集
                sentence:1,
                dialogShow:false,
                courseList:[],
                bookList:[],
                teachList:[],
                unitList:[],
                courseId:null,
                courseName:'',
                bookId:null,
                bookName:'',
                teachId:null,
                teachName:'',
                unitId:null,
                sentenceType:1,
                isFinish:false,
                errorShow:false,
                tableData: [],
                title:'',
                textBooKId:'',
                dialogPage:1,
                lessonList:[],
                lessonInfo:'',
                lessonAudio:'',
                lessonInfoZh:'',
                lessonInfoEn:'',
                isPlay:false,//是否播放
                audio:'',
                h:'00',//音频时长-小时
                i:'00',//音频时长-分钟
                s:'00',//音频时长-秒
                nowH:'00',//音频当前播放-小时
                nowM:'00',//音频当前播放-分钟
                nowS:'00',//音频当前播放-秒
                sentenceList:[],
                sentenceTotal:0,
                nowIndex:0,
                progressWidth:'0%',
                rightNum:0,
                errorNum:0,
                seconds: 300,
                jumpType:1,
                score:0,
                questionList:[],
                achieveId:null,//测试报告id
                tableTotal:0,
                tablePage:1,
				clickShow:false,//通过点击展示课程列表
				unitListNum: 0,//共几个单元
				progress: 0,
				timerF: null,
            }
        },
        methods:{
			// 删除单个词汇
			deleteSingle(index) {
				console.log('删除单个词汇index',index)
				// console.log('ilistenInput——name',this.sentenceList[this.nowIndex].listenInput[index].name)
				this.sentenceList[this.nowIndex].listenOptions.forEach(item =>{
					// console.log('item.name',item.name)
					if(item.name == this.sentenceList[this.nowIndex].listenInput[index].name) {
						item.choose = false
					}
				})
				this.sentenceList[this.nowIndex].listenInput[index].name = ''
			},
			
			// 选择选项
			chooseTheOptions(index){
				console.log('index',index)
				if(this.sentenceList[this.nowIndex].listenOptions[index].choose) return
				try{
					this.sentenceList[this.nowIndex].listenInput.forEach(item =>{
						if(!item.name){
							item.name = this.sentenceList[this.nowIndex].listenOptions[index].name
							throw new Error('退出')
						}
					})
				}catch (e) {
					console.log('选择选项err')
				}
				this.sentenceList[this.nowIndex].listenOptions[index].choose = true
			},
			
			// 获取句子列表
			getSentenceList(){
				console.log('获取句子同步列表，this.teachId',this.teachId)
			  if(!this.unitId) return Message({message: '请先选择单元',type: 'error',center: true,offset: 500})
			  if(!this.teachId) return Message({message: '请先选择教材',type: 'error',center: true,offset: 500})
			  let param = {
			      id:this.teachId,
			      pageNum:1,
			      pageSize:999,
			      unit:this.unitId
			  }
			  this.sentenceType = 1;
			  this.nowIndex = 0
			    getSentenceList(param).then(res =>{
					if(res.total){
						this.clickShow = true
						if(timer){
							clearInterval(timer)
							timer = null
						}
						res.rows.forEach(item =>{
							console.log('获取句子item',item)
						    item.listenInput = []
						    item.listenOptions = []
						    item.right = []
						    item.myAnswer = ''
						    let arr = item.content.split(' ')
						    arr.forEach(arrItem =>{
						        item.listenInput.push({name:''})
						        item.right.push({name:arrItem})
						        item.listenOptions.push({name:arrItem,choose:false})
						    })
						    item.listenOptions.sort(function () {
						        return Math.random() - 0.5
						    })
						})
						this.rightNum = 0
						this.errorNum = 0
						this.score = 0
						this.isFinish = false
						this.dialogShow = false
						this.sentenceList = res.rows
						this.sentenceTotal = res.total
						this.progressWidth = ((this.nowIndex + 1)/this.sentenceTotal)*100 + '%'
						this.playTheAudio()
						this.cutDown()
						// console.log('获取句子列表this.sentenceList',this.sentenceList)
						console.log('获取句子列表this.sentenceTotal',this.sentenceTotal)
					}else{
						Message({message: '该单元下还没有录入题目，换一个试试吧',type: 'error',center: true,offset: 500})
					}
			    })
			},
			
			// 关闭弹窗
			closeModal(){
				// this.$router.go(0);
				if(this.clickShow){
					this.clickShow = false
				}else{
					this.textType = 1
				}
				
			},
            // 查看错题详情
            hanldetoCheckError(id){
                console.log('查看错题详情id',id)
				this.questionList = []
                let param ={
                    achieveId:id,
					pageSize:999,
                    type:13
                }
                selectSubjectReportList(param).then(res =>{
					// console.log('查看错题详情res',res)
					res.data.rows.forEach(item =>{
						item.subjectBodyContent = item.subjectBody.content
						if(item.subjectBodyContent.trim() == item.answer.trim()){
							item.isRight = true
						}else{
							item.isRight = false
						}
						this.questionList.push({content:item.subjectBody.content,answer:item.answer,translate:item.subjectBody.translate,isRight:item.isRight,subjectId:item.id})
					})
                    this.errorShow = true
                })
            },
          
			// 再来一次
            tryAgian(flag){
				if(flag) {
					this.unitId++
					console.log('下一单元')
				}
				this.sentenceList = []
				this.questionList = []
				this.sentenceType = 1
				this.nowIndex = 0
				clearInterval(timer)
				timer = null
				this.getSentenceList()
				console.log('再来一次')
				
            },
		   
			// 下一个
            handleToNext(){
				let answer = [];
				let right = [];
				let myAnswer = ''
				console.log('下一个this.nowIndex', this.nowIndex)
				this.sentenceList[this.nowIndex].listenInput.forEach(item =>{
					answer.push(item.name)
					myAnswer = myAnswer + item.name
				})
				
                this.sentenceList[this.nowIndex].right.forEach(item =>{
                    right.push(item.name)
                })
                if(this.jumpType == 1){
                    if(!myAnswer) return Message({message: '你的答案不能为空',type: 'error',center: true,offset: 500})
                }
                clearInterval(timer)
                timer = null
                this.seconds = 300
                this.jumpType = 1
				// 不是最后一题
              if((this.nowIndex + 1) < this.sentenceTotal){
				  console.log('不是最后一题this.nowIndex',this.nowIndex);
				  console.log(answer.join(' ') == this.sentenceList[this.nowIndex].content);
                  if(answer.toString() == right.toString()){
					  console.log('答案正确');
                      this.rightNum ++
                      this.sentenceList[this.nowIndex].isRight = true
                  }else{
					  console.log('答案错误')
                      this.errorNum ++
                      this.sentenceList[this.nowIndex].isRight = false
                      this.sentenceList[this.nowIndex].answer = answer.join(' ')
					  console.log('答案错误this.sentenceList[this.nowIndex].answer',this.sentenceList[this.nowIndex].answer)
                  }
					this.nowIndex ++;
					this.cutDown()
					this.progressWidth = ((this.nowIndex + 1)/this.sentenceTotal)*100 + '%';
					if(this.sentenceType == 1 || this.sentenceType == 3){
						this.playTheAudio()
					}
				  // 最后一题
				}else{
					console.log('最后一题this.nowIndex',this.nowIndex);
					if(answer.toString() == right.toString()){
						console.log('答案正确');
                      this.rightNum ++
                      this.sentenceList[this.nowIndex].isRight = true
                  }else{
					  console.log('答案错误')
                      this.errorNum ++
                      this.sentenceList[this.nowIndex].isRight = false
					  this.sentenceList[this.nowIndex].answer = answer.join(' ')
					  console.log('答案错误this.sentenceList[this.nowIndex].answer',this.sentenceList[this.nowIndex].answer)
                  }
                  // if(this.sentenceType < 4){
                  if(this.sentenceType < 1){
                      this.nowIndex = 0
                      this.progressWidth = ((this.nowIndex + 1)/this.sentenceTotal)*100 + '%';
                      this.sentenceList.forEach(item =>{
                          item.listenInput.forEach(inputItem =>{
                              inputItem.name = ''
                          })
                          item.listenOptions.forEach(optionsItem =>{
                              optionsItem.choose = false
                          })
                          if(item.isRight){
                              item.answer = item.content
                          }
                          this.questionList.push({content:item.content,answer:item.answer,translate:item.translate,isRight:item.isRight,subjectId:item.id})
                      })
                      console.log('我的答案4this.questionList', this.questionList)
                      this.sentenceType ++
                      this.cutDown()
                      if(this.sentenceType == 3){
                          this.playTheAudio()
                      }
                  }else{
                      this.sentenceList.forEach(item =>{
                          item.listenInput.forEach(inputItem =>{
                              inputItem.name = ''
                          })
                          item.listenOptions.forEach(optionsItem =>{
                              optionsItem.choose = false
                          })
                          if(item.isRight){
                              item.answer = item.content
                          }
                          this.questionList.push({content:item.content,answer:item.answer,translate:item.translate,isRight:item.isRight,subjectId:item.id})
                      })
                      this.score = ((this.rightNum * 100)/(this.rightNum+this.errorNum)).toFixed(0)
                      this.isFinish=true
                      let param = {
                          unit:this.unitId,
                          type:13,
                          point:this.score,
                          title:this.bookName,
                          content:'句子同步-'+this.teachName+'unit'+this.unitId,
                          parentId:0,
                      }
                      uploadScore(param).then(res =>{
                          this.achieveId = res.data
                          this.uploadSubjectIdReportList()
                      })
                  }
              }
            },
		            
			// 提交题目记录
            uploadSubjectIdReportList(){
				let ids = []
				let answers = []
				this.questionList.forEach(item =>{
					ids.push(item.subjectId)
					answers.push(item.answer)
				})
				ids = ids.join(',')
				answers = answers.join('、')
				let param = {
					answers:answers,
					ids:ids,
					type:13,
					achieveId:this.achieveId,
				}
				console.log('提交题目记录param',param)
                uploadSubjectIdReportList(param).then(res =>{
					console.log('提交题目记录res',res)
                })
            },
            
			// 开始计时
            cutDown(){
				this.seconds = 300
              timer = setInterval(()=>{
                  this.seconds--
                  if (this.seconds < 0) {
                      this.jumpType = 2
                      this.handleToNext()
                      return
                  }
              },1000)
            },
           
			// 播放音频
            playTheAudio(){
                let audio = new Audio()
                audio.src = this.sentenceList[this.nowIndex].url
                audio.play()
            },
           
			
          
			// 切换textTabIndex
            handleToChangeTextBookTab(index){
                this.chooseTabIndex = index
                this.getBookList()
            },
         
			// 查看课本目录
            handleToCheckTextBook(id,title){
                this.textBooKId = id
                this.title = title
                let param ={
                    id:this.textBooKId,
                    pageNum:this.dialogPage,
                    pageSize:999,
                }
                getLessonList(param).then(res =>{
                    this.lessonList = res.rows
                })
                this.textBookStatus = 2
            },
           
			// 查看课本详情
            handleToTextBookDetail(id){
                let param = {
                    id:id
                }
                getLessonInfo(param).then(res =>{
                    this.h = '00'
                    this.i = '00'
                    this.s = '00'
                    this.nowS = '00'
                    this.nowH = '00'
                    this.nowM = '00'
                    this.value = 0
					this.progress = 0
					if(this.isPlay) {
						this.audio.pause()
					}
					this.isPlay = false
					clearInterval(this.timerF)
					
                    this.lessonInfo = res.data.content
                    this.lessonInfoEn = res.data.content
                    this.lessonInfoZh = res.data.translate
                    this.audio = new Audio()
                    this.audio.src = res.data.url
                    this.audio.oncanplay = () =>{
                        console.log(this.audio.duration)
                        this.getAudioTime(this.audio.duration)
                    }
                    // this.lessonAudio = res.data.url
                    this.textBookStatus = 3
                    this.headerTabIndex = 1
                })
            },
          
			// 播放音频
			playTheVoice() {
				clearInterval(this.timerF)
				this.timerF = null
				if(!this.isPlay){
					this.audio.play();
					this.isPlay = true
					this.timerF = setInterval(()=> {
						console.log('this.audio.currentTime',this.audio.currentTime,this.audio.duration)
						this.getAudioPlayTime(this.audio.currentTime)
						this.value = (this.audio.currentTime / this.audio.duration) * 100;
						this.progress = this.value
						// 自然播完
						if(this.audio.currentTime >= this.audio.duration) {
							clearInterval(this.timerF)
							this.timerF = null
							this.isPlay = false
							this.value = 0
						}
					},1000)
				}else{
					this.audio.pause()
					this.isPlay = false
				}
				console.log('播放音频，播放吗',this.isPlay)
			},
         
			// 获取音频播放时长
            getAudioPlayTime(seconds){
                let [hour, minute, second] = [0, 0, 0]
                if (seconds > 0) {
                    hour = Math.floor(seconds / (60 * 60))
                    minute = Math.floor(seconds / 60) - (hour * 60)
                    second = Math.floor(seconds) - (hour * 60 * 60) - (minute * 60)
                }
                hour = hour < 10 ? ('0' + hour) : hour
                minute = minute < 10 ? ('0' + minute) : minute
                second = second < 10 ? ('0' + second) : second
                this.nowH = hour;
                this.nowM = minute;
                this.nowS = second
            },
			// 转换音频时长
			getAudioTime(seconds){
			    let [hour, minute, second] = [0, 0, 0]
			    if (seconds > 0) {
			        hour = Math.floor(seconds / (60 * 60))
			        minute = Math.floor(seconds / 60) - (hour * 60)
			        second = Math.floor(seconds) - (hour * 60 * 60) - (minute * 60)
			    }
			    hour = hour < 10 ? ('0' + hour) : hour
			    minute = minute < 10 ? ('0' + minute) : minute
			    second = second < 10 ? ('0' + second) : second
			    this.h = hour;
			    this.i = minute;
			    this.s = second
			},
           
			//拖拽进度条
			progeressChange(e) {
				console.log('进度条改变',e)
				this.audio.currentTime = this.audio.duration * (e / 100);
			},

			// 切换中英课本内容和目录
            changeTextBookTab(index){
                if(index == 0){
					console.log('切换目录')
                    this.textBookStatus = 2
					if(this.isPlay) {
						this.audio.pause()
					}
					this.isPlay = false
					clearInterval(this.timerF)
                }else if(index == 1){
                    this.lessonInfo = this.lessonInfoEn
                }else if(index == 2){
                    this.lessonInfo = this.lessonInfoZh
                }
                this.headerTabIndex = index

            },
           
			// 获取更换的教材类型
            getTypeChange(data){
				console.log('更换的教材类型data',data)
				if(this.isPlay) {
					this.audio.pause()
					this.isPlay = false
				}
				clearInterval(this.timerF)
                this.textType = data
				this.unitId = null
				this.teachId = null
				this.courseId = null
				this.bookId = null
				this.sentenceList = []
				this.questionList = []
				this.sentenceType = 1
				this.nowIndex = 0
				if(timer){
					clearInterval(timer)
					timer = null
				}
                if(this.textType == 1){
                    this.textBookStatus = 1
                }else if(this.textType == 2){
                    this.textBookStatus = 1
                    if(this.unitId){
                        this.getSentenceList()
                    }else{
                        this.dialogShow = true
                    }
                }else if(this.textType == 3){
                    this.getScoreList()
                }
            },
          
			// 切换错题列表页码
            changeTablePage(data){
              this.tablePage = data
              this.getScoreList()
            },
           
			// 获取错题集
            getScoreList(){
                let param = {
                    pageNum:this.tablePage,
                    pageSize:10,
                    type:13
                }
                getScoreList(param).then(res =>{
                    this.tableData = res.rows
                    this.tableTotal = res.total
                })
            },
           
			// 选择学段
            chooseCourse(id,name){
                this.courseId = id
                this.courseName = name
                let param ={
                    testStage:this.courseId,
                }
				console.log('选择学段this.courseName',this.courseName)
                getCategoryByTestStage(param).then(res =>{
                    this.bookList = res.rows
                })
            },
           
			// 选择课本
            chooseBook(id,name){
                this.bookId = id
                this.bookName = name
				console.log('选择课本this.bookName',this.bookName)
                let param ={
                    categoryId:id
                }
                getBookByCategory(param).then(res =>{
                    this.teachList = res.rows
                })
            },
           
			// 选择教材
            chooseTeach(id,name){
                this.teachId = id
                this.teachName = name
				console.log('选择课本this.teachName',this.teachName)
                let param ={
                    bookId:id
                }
                getUnitByBookId(param).then(res =>{
                    this.unitList = res.rows
					this.unitListNum = res.total
					console.log('共this.unitListNum',this.unitListNum)
                })
            },
           
			// 选择单元
            chooseUnit(id){
                this.unitId = id
				console.log('选择课本this.unitId',this.unitId)
				this.getSentenceList()
            },
          
			// 展示所有课程列表
            showCourseList(){
				this.clickShow = true
                this.dialogShow = true
            },
           
			
			// 撤销
            clearListen(){
                this.sentenceList[this.nowIndex].listenInput.forEach(item =>{
                    item.name =''
                })
                this.sentenceList[this.nowIndex].listenOptions.forEach(item =>{
                    item.choose = false
                })
            },
            // 显示错题
            hanldeShowError(){
				console.log(this.questionList);
                this.errorShow = true
            },
            // 获取教材列表
            getBookList(){
                let params = {
                    grade:this.textBookTab[this.chooseTabIndex].dictValue,
                    pageNum:this.textBookPage,
                    pageSize:10
                }
                getBookList(params).then(res =>{
                    console.log(res)
                    this.textBookList = res.rows
                    this.textBookTotal = res.total
                })
            },
            // 转换
            funcChangeNumToCHN (s_) {
                var _arrayCHNNum=['〇','一','二','三','四','五','六','七','八','九'];
                var _arrayCHNBit=['','十','百','千'];
                let _numArray=s_.toString().split('');
                if(_numArray.length===2&&_numArray[0]==='1'){
                    _numArray[0]='y';
                }
                for(let i=_numArray.length-1;i>=0;i--){
                    if(_numArray[i]==='0') {
                        _numArray[i]='x';
                    }  else{
                        break;
                    }
                }
                let _s='';
                let _bLast0=false;
                for(let i=0;i<_numArray.length;i++){
                    if(_numArray[i]==='x'){
                        continue;
                    }
                    if(_numArray[i]==='0'&&_bLast0){
                        _bLast0=true;
                        continue;
                    }
                    if(_numArray[i]!=='y'){//delete 1 in ten
                        _s+=_arrayCHNNum[parseInt(_numArray[i])];
                    }
                    if(_numArray[i]==='0'){
                        _bLast0=true;
                        continue;
                    }
                    _bLast0=false;

                    _s+=_arrayCHNBit[_numArray.length-i-1];
                }
                console.log(_s)
                return _s;

            }
        },
        computed:{
            NumberReturnChinese() {
                return function(value) {
                    return this.funcChangeNumToCHN(value)
                }
            }
        },
        created() {
            getGrade().then(res =>{
                this.textBookTab = res.rows
                this.courseList = res.rows
                this.getBookList()
            })
        },
        watch:{
            textBookStatus(){
                if(this.textBookStatus == 1){
                    this.audio.pause()
                }
            }
        },
		destroyed() {
			clearInterval(timer)
			timer = null
			console.log('destroyed销毁了~~~~~~')
			if(this.isPlay) {
				this.audio.pause()
				this.isPlay = false
			}
			
			clearInterval(this.timerF)
		}
    }
</script>

<style scoped lang="less" scoped>
    .textBook{
        width: 100%;
        background-image: url("~@/assets/image/2.png");
        background-repeat: no-repeat;
        background-size: cover;
        .el-main {
            padding: 0;
        }
        .el-header{
            padding: 0;
        }
        .textBook-main{
            display: flex;
            flex-direction: column;
            width: 1200px;
            margin: 0 auto;
            margin-top: 80px;
            .textBook-main-content{
                padding-bottom: 95px;
                display: flex;
                .textBook-main-detail{
                    width: 975px;
                    min-height: 700px;
                    background: #FFFFFF;
                    margin-left: 30px;
                    box-shadow: 0 4px 17px 0 rgba(0,0,0,0.05);
                    display: flex;
                    flex-direction: column;
                    .textBook-main-detail-tab{
                        width: 875px;
                        display: flex;
                        height: 40px;
                        margin: 50px 50px 0 50px;
                        border-bottom: 1px solid #70CDCF;
                        .tab-item{
                            width: 120px;
                            height: 40px;
                            border-top: 1px solid #70CDCF;
                            border-left: 1px solid #70CDCF;
                            border-right: 1px solid #70CDCF;
                            border-radius: 7px 7px 0 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 17px;
                            color: #000000;
                            cursor: pointer;
                            &:hover{
                                background: #70CDCF;
                            }
                        }
                        .activeTab{
                            background: #70CDCF !important;
                        }
                    }
                    .textBook-booklist{
                        width: 925px;
                        margin: 0 0 0 50px;
                        display: flex;
                        flex-wrap: wrap;
                        .textBook-bookitem{
                            width: 150px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-size: 14px;
                            color: #000000;
                            margin: 30px 30px 20px 0;
                            cursor: pointer;
                            .bookImg{
                                width: 109.5px;
                                height: 150px;
                                margin-bottom: 15px;
                            }
                        }
                    }
                    .catelog-header{
                        width: 875px;
                        padding-bottom: 15px;
                        border-bottom: 1px solid #70CDCF;
                        font-size: 36px;
                        color: #000000;
                        margin: 50px 50px 0 50px;
                    }
                    .catelog-list{
						// border: 1px solid #70CDCF;
                        width: 925px;
						height: 630px;
                        margin: 30px 0 0 50px;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: flex-start;
						overflow-y: scroll;
                        .catelog-item{
							padding: 0 30px;
							margin-bottom: 30px;
                            width: 340px;
                            height: 75px;
							display: flex;
							align-items: center;
							
                            background: #FAFAFA;
                            border-radius: 7px;
                            font-size: 17px;
                            color: #000000;
                            font-weight: bold;
                            cursor: pointer;
                            &:nth-child(2n){
                                margin-left: 75px;
                            }
                            &:hover{
                                background: #70CDCF;
                            }
							& > .catelog-index {
								display: inline-block;
								width: 60px;
							}
							& > .catelog-title {
								flex: 1;
							}
                        }
                    }
                    .textBook-detail-header{
                        width: 875px;
                        display: flex;
                        height: 40px;
                        margin: 50px 50px 0 50px;
                        border-bottom: 1px solid #70CDCF;
                        .tab-item{
                            width: 120px;
                            height: 40px;
                            border-top: 1px solid #70CDCF;
                            border-left: 1px solid #70CDCF;
                            border-right: 1px solid #70CDCF;
                            border-radius: 7px 7px 0 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 17px;
                            color: #000000;
                            cursor: pointer;
                            &:hover{
                                background: #70CDCF;
                            }
                        }
                        .activeTab{
                            background: #70CDCF !important;
                        }
                    }
                    .voicePlay{
                        width: 875px;
                        display: flex;
                        align-items: center;
                        margin: 28px 50px 0 50px;
                        .progress{
                            width: 841px;
                            margin-left: 16px;
                            /*height: 5px;*/
                            /*background: rgba(238,238,238,0.90);*/
                            /*border-radius: 2.5px;*/
                            /*position: relative;*/
                            /*.playFlag{*/
                            /*    position: absolute;*/
                            /*    left: 0;*/
                            /*    top: -13px;*/
                            /*}*/
                            /deep/.el-slider__bar{
                                background-color: rgba(103,104,196,0.80) !important;
                            }
                            /deep/.el-slider__button{
                                width: 19px;
                                height: 29px;
                                background-image: url("~@/assets/image/ylc/23.png");
                                background-repeat: no-repeat;
                                background-size: 100% 100%;
                                border: none;
                            }
                        }
                    }
                    .voice-time{
                        width: 875px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        font-size: 14px;
                        color: #000000;
                        margin: 0 50px;
                    }
                    .textBook-detail-content{
						// border: 1px solid #000000;
						padding: 30px;
                        width: 815px;
                        margin: 30px 50px;
                        height: 387px;
                        overflow-y: scroll;
                        background: #FAFAFA;
                        border-radius: 7px;
                        .textBook-content-title{
                            margin: 20px 20px 13px 20px;
                            font-size: 22px;
                            color: #000000;
                            font-weight: bold;
                        }
                        p{
                            margin-left: 20px;
                        }
                        &::-webkit-scrollbar {
                            width: 5px;
                            height: 1px;
                        }
                        &::-webkit-scrollbar-thumb { //滑块部分
                            border-radius: 5px;
                            background-color: #70CDCF;
                        }
                        &::-webkit-scrollbar-track { //轨道部分
                            border-radius: 5px;
                        }
                    }
                }
                .sentence{
                    width: 975px;
                    min-height: 700px;
                    background: #FFFFFF;
                    margin-left: 30px;
                    box-shadow: 0 4px 17px 0 rgba(0,0,0,0.05);
                    display: flex;
                    flex-direction: column;
                    .sentence-header{
                        width: 875px;
                        margin: 35px 50px;
                        border-bottom: 1px solid #70CDCF;
                        font-size: 28px;
                        color: #000000;
                        display: flex;
                        align-items: center;
                        height: 65px;
                        img{
                            width: 15px;
                            height: 12px;
                            margin-right: 15px;
                            cursor: pointer;
                        }
                        span{
                            cursor: pointer;
                        }
						.triangle {
							margin-left: 10px;
							width: 0;
							height: 0;
							border-left: 10px solid transparent;
							border-right: 10px solid transparent;
							border-top: 10px solid #ff0000;
						}
                    }
                    .sentence-content{
                        width: 875px;
                        margin: 0 50px;
                        display: flex;
                        flex-direction: column;
                        border: 1px solid #D8D8D8;
                        border-radius: 7px;
                        // height: 443px;
                        .sentence-content-title{
                            width: 815px;
                            margin: 30px 30px 20px 30px;
                            font-size: 17px;
                            color: #000000;
                        }
                        .sentence-question{
							// border: 0.5px solid #000000;
                            width: 840px;
                            margin: 0 30px;
                            display: flex;
                            align-items: center;
                            .sentence-question-num{
                                width: 72px;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 17px;
                                color: #2F89FC;
                                background: rgba(47,137,252,0.10);
                                border-radius: 17px;
                            }
                            .sentence-progress{
								// border: 0.58px solid #000000;
                                width: 800px;
                                height: 5px;
                                background: rgba(238,238,238,0.90);
                                border-radius: 2.5px;
                                margin-left: 10px;
                                & > div{
                                    background: rgba(255, 0, 0, 0.8);
                                    border-radius: 2.5px;
                                    height: 5px;
                                }
                            }
                        }
                        .sentence-cutDown{
                            width: 815px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 15px 30px 0 30px;
                            ont-size: 17px;
                            color: #2F89FC;
                        }
                        .sentence-listen{
                            width: 815px;
                            display: flex;
                            flex-direction: column;
                            margin: 30px 30px 0 30px;
                            .sentence-listen-input{
								// border: 1px solid #0B99FF;
								font-size: 22px;
                                width: 815px;
                                display: flex;
								flex-wrap: wrap;
                                align-items: center;
                                .sentence-listen-input-item{
									position: relative;
                                    max-width: 70px;
                                    min-width: 40px;
                                    height: 17px;
                                    margin: 28px 5px 0;
                                    border-bottom: 2px solid #B1B1B1;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
									.listen-close {
										position: absolute;
										top: -30px;
										right: 0;
										width: 20px;
										height: 20px;
										
									}
                                }
                                .noBorder{
                                    border: none;
                                }
                            }
                            .sentence-listen-opionts{
								// border: 1px solid #0B99FF;
                                width: 815px;
                                margin-top: 36px;
								
								display: flex;
								align-items: center;
								flex-wrap: wrap;
                                .sentence-listen-opionts-item {
                                    height: 40px;
                                    padding: 0 10px;
									margin: 10px 10px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 22px;
                                    color: #000000;
                                    background: rgba(238,238,238,0.90);
                                    border: 1px solid #B1B1B1;
                                    border-radius: 7px;
                                    cursor: pointer;
                                }
                                .activeOptions{
                                    background: #70CDCF;
                                    border: 1px solid #70CDCF;
                                }
                            }
                            .sentence-listen-button{
                                width: 815px;
                                margin: 30px 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .white-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    border: 1px solid #70CDCF;
                                    border-radius: 27.5px;
                                    margin-right: 30px;
                                    cursor: pointer;
                                }
                                .blue-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    background: #70CDCF;
                                    border-radius: 27.5px;
                                    cursor: pointer;
                                }
                            }
                        }
                        .sentence-Translate{
                            width: 815px;
                            display: flex;
                            flex-direction: column;
                            margin: 30px 30px 0px 30px;
                            .sentence-Translate-zh{
                                width: 815px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 26px;
								margin-bottom: 10px;
                            }
                            .sentence-listen-input{
                                width: 815px;
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
								font-size: 22px;
                                .sentence-listen-input-item{
									position: relative;
                                    width: 70px;
                                    height: 17px;
                                    margin: 28px 5px 0;
                                    border-bottom: 2px solid #B1B1B1;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
									.listen-close {
										position: absolute;
										top: -30px;
										right: 0;
										width: 20px;
										height: 20px;
										
									}
                                }
                                .noBorder{
                                    border: none;
                                }
                            }
                            .sentence-listen-opionts{
                                width: 815px;
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
								margin-top: 30px;
								
                                .sentence-listen-opionts-item{
									margin: 10px 10px;
                                    height: 40px;
                                    padding: 0 10px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 22px;
                                    color: #000000;
                                    background: rgba(238,238,238,0.90);
                                    border: 1px solid #B1B1B1;
                                    border-radius: 7px;
                                    cursor: pointer;
                                }
                                .activeOptions{
                                    background: #70CDCF;
                                    border: 1px solid #70CDCF;
                                }
                            }
                            .sentence-listen-button{
                                width: 815px;
                                // margin-top: 52px;
								margin: 30px 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .white-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    border: 1px solid #70CDCF;
                                    border-radius: 27.5px;
                                    margin-right: 30px;
                                    cursor: pointer;
                                }
                                .blue-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    background: #70CDCF;
                                    border-radius: 27.5px;
                                    cursor: pointer;
                                }
                            }
                        }
                        .sentence-listenWirte{
                            width: 815px;
                            display: flex;
                            flex-direction: column;
                            margin: 30px 30px 0 30px;
                            .ListenWirte-input{
                                width: 815px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-top: 20px;
                                input{
                                    width: 130px;
                                    height: 60px;
                                    line-height: 60px;
                                    border: 2px solid #038ad0;
                                    border-radius: 10px;
                                    background-color: #e7f3fa;
                                    color: #038ad0;
                                    font-size: 24px;
                                    text-align: center;
                                    font-family: 'Helvetica Neue';
                                    outline: none;
                                    margin-right: 10px;
                                }
                            }
                            .sentence-listenWirte-button{
                                width: 815px;
                                margin-top: 52px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .white-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    border: 1px solid #70CDCF;
                                    border-radius: 27.5px;
                                    margin-right: 30px;
                                    cursor: pointer;
                                }
                                .blue-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    background: #70CDCF;
                                    border-radius: 27.5px;
                                    cursor: pointer;
                                }
                            }
                        }
                        .sentence-dication{
                            width: 815px;
                            display: flex;
                            flex-direction: column;
                            margin: 30px 30px 0 30px;
                            .dication-zh{
                                font-size: 24px;
                                color: #222;
                                font-weight: 700;
                                text-align: center;
                            }
                            .dication-input{
                                width: 815px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-top: 20px;
                                input{
                                    width: 130px;
                                    height: 60px;
                                    line-height: 60px;
                                    border: 2px solid #038ad0;
                                    border-radius: 10px;
                                    background-color: #e7f3fa;
                                    color: #038ad0;
                                    font-size: 24px;
                                    text-align: center;
                                    font-family: 'Helvetica Neue';
                                    outline: none;
                                    margin-right: 10px;
                                }
                            }
                            .sentence-dication-button{
                                width: 815px;
                                margin-top: 52px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .white-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    border: 1px solid #70CDCF;
                                    border-radius: 27.5px;
                                    margin-right: 30px;
                                    cursor: pointer;
                                }
                                .blue-button{
                                    width: 120px;
                                    height: 45px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 17px;
                                    color: #000000;
                                    background: #70CDCF;
                                    border-radius: 27.5px;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .Finish-score{
						// border: 1px solid #000000;
                        width: 875px;
                        margin: 0 50px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        & > div:first-child{
                            margin-top: 30px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
							& > img {
								// border: 1px solid #aaaa7f;
								width: 300px;
								height: 300px;
							}
                        }
                        & > div:nth-child(2){
                            margin-top: 30px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 32px;
                            color: #E02020;
                            font-weight: bold;
                        }
                        & > div:nth-child(3){
                            margin-top: 30px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 28px;
                            color: #000000;
                            font-weight: bold;
                        }
                        & > div:nth-child(4){
							// border: 1px solid #70CDCF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 40px 0;
							font-size: 20px;
							& > div {
								border: 1px solid #70CDCF;
								border-radius: 27.5px;
								width: 160px;
								height: 50px;
								display: flex;
								align-items: center;
								justify-content: center;
								color: #000000;
								cursor: pointer;
							}
                            & > div:first-child{
                                margin-right: 30px;
                            }
                            & > div:nth-child(2){
                                background: #70CDCF;
                            }
                        }
                    }
                }
                .errorQuestion-list{
                    width: 975px;
                    min-height: 700px;
                    background: #FFFFFF;
                    margin-left: 30px;
                    box-shadow: 0 4px 17px 0 rgba(0,0,0,0.05);
                    display: flex;
                    flex-direction: column;
                    .errorQuestion-list-title{
                        width: 975px;
						font-size: 28px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 50px;
                    }
                    .errorQuestion-list-table{
                        width: 875px;
                        margin: 30px 50px;
                        .choosePage{
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            margin-top: 20px;
                        }
                        .checkButton{
							width: 70px;
							height: 30px;
							margin: 2px;
                            background: #FA6400;
                            border-radius: 17.5px;
                            border: none!important;
                            outline:none;
                            cursor: pointer;
                            font-size: 14px;
                            color: #FFFFFF;
                            &:hover{
                                opacity: 0.8;
                            }
                        }
                        /deep/.has-gutter .is-leaf {
                            padding: 12px 0;
                            // border: none;
                        }
                        /deep/.el-table td,
                        .el-table th {
                            padding: 0;
                            // border: none;	
                        }
                        /deep/.el-table__row {
                            height: 60px;
                        }
                    }
                }
            }
        }
    }
    /deep/.tableHeader{
        background-color: #70CDCF !important;
        color: #FFFFFF !important;
        font-size: 17px !important;
        font-weight: normal !important;
        text-align: center !important;
        height: 50px !important;
    }
    /deep/.tableCell{
        text-align: center !important;
        font-size: 14px !important;
        color: #000000 !important;
        height: 65px !important;
    }
    .course-title{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        color: #000000;
        font-weight: bold;
        img{
            width: 24px;
            height: 28px;
            margin-right: 15px;
        }
    }
    .course-list{
        /*width: 830px;*/
        /*height: 360px;*/
        background: #FFFFFF;
        border: 1px solid rgba(238,238,238,0.90);
        border-radius: 2px;
        margin: 30px 15px;
        .course-list-header{
            width: 830px;
            display: flex;
            background: #FAFAFA;
            border-bottom: 1px solid #F5F5F5;
        }
        .course-list-content{
			// border: 1px solid #000000;
            min-width: 830px;
            height: 300px;
            display: flex;
			font-size: 18px;
            .learnPeriod{
                /*width: 150px;*/
                height: 300px;
                overflow-x: hidden;
                overflow-y: scroll;
                background: #FAFAFA;
                &::-webkit-scrollbar {
                    width: 5px;
                    height: 1px;
                }
                &::-webkit-scrollbar-thumb { //滑块部分
                    border-radius: 5px;
                    background-color: #70CDCF;
                }
                &::-webkit-scrollbar-track { //轨道部分
                    border-radius: 5px;
                    background: rgba(238,238,238,0.90);
                }
                .learnPeriod-item{
                    width: 150px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // font-size: 22px;
                    color: #000000;
                    cursor: pointer;
                    &:hover{
                        background: #FCC414;
                    }
                }
                .chooseClass{
                    background: #FCC414 !important;
                }
            }
            .book-list{
                width: 340px;
                height: 300px;
                overflow-x: hidden;
                overflow-y: scroll;
                background: #FFFFFF;
                &::-webkit-scrollbar {
                    width: 5px;
                    height: 1px;
                }
                &::-webkit-scrollbar-thumb { //滑块部分
                    border-radius: 5px;
                    background-color: #70CDCF;
                }
                &::-webkit-scrollbar-track { //轨道部分
                    border-radius: 5px;
                    background: rgba(238,238,238,0.90);
                }
                .book-item{
                    width:340px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // font-size: 22px;
					font-size: 18px;
                    color: #000000;
                    cursor: pointer;
                    &:hover{
                        background: #FCC414;
                    }
                }
                .chooseClass{
                    background: #FCC414 !important;
                }
            }
            .teach-list{
                width: 170px;
                height: 300px;
                overflow-x: hidden;
                overflow-y: scroll;
                background: #FFFFFF;
                &::-webkit-scrollbar {
                    width: 5px;
                    height: 1px;
                }
                &::-webkit-scrollbar-thumb { //滑块部分
                    border-radius: 5px;
                    background-color: #70CDCF;
                }
                &::-webkit-scrollbar-track { //轨道部分
                    border-radius: 5px;
                    background: rgba(238,238,238,0.90);
                }
                .teach-item{
                    width:170px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // font-size: 22px;
					font-size: 18px;
                    color: #000000;
                    cursor: pointer;
                    &:hover{
                        background: #FCC414;
                    }
                }
                .chooseClass{
                    background: #FCC414 !important;
                }
            }
            .unit-list{
                width: 170px;
                height: 300px;
                overflow-x: hidden;
                overflow-y: scroll;
                background: #FFFFFF;
                &::-webkit-scrollbar {
                    width: 5px;
                    height: 1px;
                }
                &::-webkit-scrollbar-thumb { //滑块部分
                    border-radius: 5px;
                    background-color: #70CDCF;
                }
                &::-webkit-scrollbar-track { //轨道部分
                    border-radius: 5px;
                    background: rgba(238,238,238,0.90);
                }
                .unit-item{
                    width:170px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // font-size: 22px;
					font-size: 18px;
                    color: #000000;
                    cursor: pointer;
                    &:hover{
                        background: #FCC414;
                    }
                }
                .chooseClass{
                    background: #FCC414 !important;
                }
            }
        }
    }
    .dialog-button{
        width: 830px;
        display: flex;
        align-items: center;
        justify-content: center;
        button{
            width: 125px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            color: #000000;
            border: none !important;
            outline: none;
            background: #70CDCF;
            cursor: pointer;
            border-radius: 17.5px;
            font-weight: bold;
            &:hover{
                opacity: 0.8;
            }
        }
    }
    .error-title{
        width: 830px;
        margin: 0 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 20px;
        font-size: 28px;
        color: #000000;
        font-weight: bold;
        border-bottom: 1px solid #70CDCF;
    }
    .error-list{
        width: 830px;
        margin: 7px 35px 40px 35px;
        height: 528px;
        overflow-y: scroll;
        overflow-x: hidden;
        background: #FFFFFF;
        &::-webkit-scrollbar {
            width: 5px;
            height: 1px;
        }
        &::-webkit-scrollbar-thumb { //滑块部分
            border-radius: 5px;
            background-color: #70CDCF;
        }
        &::-webkit-scrollbar-track { //轨道部分
            border-radius: 5px;
            background: rgba(238,238,238,0.90);
        }
        .error-item{
            width: 830px;
            display: flex;
            align-items: center;
            height: 132px;
            .error-item-left{
				// border: 1px solid #000000;
                flex: 1;
                display: flex;
                justify-content: center;
                flex-direction: column;
                & > div:first-child{
                    font-size: 22px;
                    color: #000000;
                    font-weight: bold;
                    margin-left: 25px;
                }
                & > div:nth-child(2){
                    font-size: 22px;
                    color: #2F89FC;
                    margin-left: 72px;
                    margin-top: 5px;
                }
                & > div:nth-child(3){
                    font-size: 22px;
                    color: #B1B1B1;
                    margin-left: 71px;
                    margin-top: 5px;
                }
            }
            .error-item-right{
                // flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                img{
                    margin-right: 25px;
                }
            }
        }
        .error-item + .error-item{
            border-top: 1px solid #F5F5F5;
        }
    }
</style>